import type { ReactNode } from 'react';

/** Every empty state names the thing to add and carries the add button. */
export function EmptyState({
  title,
  body,
  action,
}: {
  title: string;
  body: string;
  action?: ReactNode;
}) {
  return (
    <div className="panel flex flex-col items-start gap-3 p-8">
      <h2 className="font-display text-titleSm text-ink">{title}</h2>
      <p className="max-w-prose text-body text-leaf-soft">{body}</p>
      {action}
    </div>
  );
}
